import { Link, useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { ErrorState, ErrorShell } from '@/components/error-state';
import { ConsoleNav } from '@/admin/ConsoleNav';
import { classify } from '@/lib/failure';

// Lives here rather than with the other failure screens because it is the only
// one needing the page strip, which keeps those free of any import from this
// half of the app.
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  const failure = classify(error);

  // A refusal means there is no session behind these links, so offering them
  // sends someone in a circle. Decided from the failure rather than the route: a
  // gate rejecting and a page throwing arrive here alike. Only a refusal — being
  // offline says nothing about the session, and the strip still navigates.
  const gated = failure.kind === 'auth';

  return (
    <ErrorShell>
      {!gated && (
        <div className="mb-5 border-b pb-2">
          <ConsoleNav />
        </div>
      )}
      <ErrorState
        failure={failure}
        size="page"
        // Invalidate before clearing. Clearing is synchronous, so the other
        // order re-renders against the same stale load and throws again before
        // a refetch lands.
        onRetry={() => {
          void router.invalidate().then(reset);
        }}
      >
        {gated && (
          <Button variant="outline" size="sm" asChild>
            <Link to="/login">Sign in</Link>
          </Button>
        )}
      </ErrorState>
    </ErrorShell>
  );
}
